module.exports = __webpack_public_path__ + "img/code_create_select.140e3b28.png";